<template>
    <main-layout>
       <div class="completeDiv">
          <div class="container ">
              <H1 class="pageTitle isPoppins">Account Settings</H1>
             
              <div class="columns">
                <div class="column">
                <div class="limitWidth top40">
                    <form class="form accSettingsForm" v-on:submit.prevent="submitForm1" v-if="showForm" name="form1" data-vv-scope="form1">
                        <div class="field is-size-4"  >
                            Change Personal Information:
                        </div>
                        <div class="field" :class="{formError: errors.first('form1.fName') }">
                            First Name:*
                            <input type="text" class="input is-warning" name="fName"  v-validate="'required'" v-model="form.fName" />
                            <p class="help is-danger" >
                                {{ errors.first('form1.fName') }}
                            </p>
                        </div>
                        <div class="field" :class="{formError: errors.first('form1.lName') }">
                            Last Name:*
                            <input type="text" class="input is-warning" name="lName" v-validate="'required'" v-model="form.lName"/>
                            <p class="help is-danger" >
                                {{ errors.first('form1.lName') }}
                            </p>
                        </div>
                        <div class="field">
                            Company:
                            <input type="text" class="input is-warning" name="Company" v-model="form.company"/>
                        </div>
                        <div class="field" :class="{formError: errors.first('form1.City') }">
                            City:*
                            <input type="text" class="input is-warning" name="City" v-validate="'required'" v-model="form.city"/>
                            <p class="help is-danger" >
                                {{ errors.first('form1.City') }}
                            </p>
                        </div>
                        <div class="field" :class="{formError: errors.first('form1.Country') }">
                            Country:*<br/>
                            <div class="select is-warning width100">
                                <select name="Country" class="width100"  v-validate="'required'" v-model="form.country">
                                    <option disabled value="">Select...</option>
                                    <option v-for="item in countries" :key="item.code" v-bind:value="item.code">{{item.name}}</option>
                                </select>
                            </div>
                            <p class="help is-danger" >
                                {{ errors.first('form1.Country') }}
                            </p>
                        </div>
    
                        <div class="field">
                            <button id="save1" type="submit" class="button is-warning top10">SAVE</button>
                        </div>
    
                    </form>
    
                
    
                    <form class="form accSettingsForm" v-on:submit.prevent="submitForm2" v-if="showForm" name="form2" data-vv-scope="form2">
                        <div class="field is-size-4"  >
                            Change Password:
                        </div>
                        <div class="field" :class="{formError: errors.first('form2.OldPassword') } ">
                            Old Password:*
                            <input class="input is-warning" type="password" name="OldPassword" v-validate="{required: true}" v-model="form2.oldPassword"  data-vv-scope="form2"/>
                            <p class="help is-danger" >
                                {{ errors.first('form2.OldPassword') }}
                            </p>
                            </div>
                        <div class="field" :class="{formError: errors.first('form2.Password') }" >
                            New Password:*
                            <input class="input is-warning" type="password" name="Password" v-validate="{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}" v-model="form2.password"/>
                            <p class="help is-danger" >
                                {{ errors.first('form2.Password') }}
                            </p>
                            <span class="is-size-8 has-text-weight-light">(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)</span>
                        </div>
                        <div class="field" :class="{formError: errors.first('form2.password2') }">
                            Confirm Password:*
                            <input class="input is-warning" type="password" name="password2" v-validate="{required:true, is: form2.password}" />
                            <p class="help is-danger" >
                                {{ errors.first('form2.password2') }}
                            </p>
                        </div>
    
                        <div class="field">
                            <button id="save2" type="submit" class="button is-warning top10">SAVE</button>
                        </div>
                    </form>
    
                  
    
                    <form class="form accSettingsForm" v-on:submit.prevent="submitForm3" v-if="showForm" name="form3" data-vv-scope="form3">
                        <div class="field is-size-4"  >
                            Change Email:
                        </div>
                        <div class="has-text-weight-bold">
                            Currently: {{this.$root.userAttrs.email}}
                        </div>
                        <div class="top20" >NOTE: You use your email address to log in. You will be sent a confirmation code to the new email address you provide. If you
                            do not have access to the new email address, do not proceed. You will loose access to your services.
                        </div>
                        <div class="field top10" :class="{formError: errors.first('form3.email') }">
                            Email:*
                            <input type="text" class="input is-warning" name="email" v-validate="'required|email'" v-model="form3.email" />
                            <p class="help is-danger" >
                                {{ errors.first('form3.email') }}
                            </p>
                        </div>
                        <div class="field" :class="{formError: errors.first('form3.email2') }">
                            Confirm Email:*
                            <input type="text" class="input is-warning" name="email2" v-validate="{required:true, is: form3.email}"  />
                            <p class="help is-danger" >
                                {{ errors.first('form3.email2') }}
                            </p>
                        </div>
    
                        <div class="field">
                            <button id="save3" type="submit" class="button is-warning top10">SAVE</button>
                        </div>
                    </form>
    
                  
                     <form class="form accSettingsForm" v-on:submit.prevent="submitForm4" v-if="showForm" name="form4" data-vv-scope="form4">
                        <div class="field is-size-5"  >
                            Request Your Data:
                        </div>
                       
                        <div class="top20" >You may request a copy of the data we store related to your account. After our team processes your request, the data will be sent to the email address registered to your account.
                        </div>
                       
    
                        <div class="field">
                            <button id="save4" type="submit" class="button is-warning top10 is-small">SEND REQUEST</button>
                        </div>
                    </form>
    
                     <div class="accSettingsForm" v-if="showForm" name="form5" data-vv-scope="form5">
                        <div class="field is-size-5"  >
                            Delete your Account
                        </div>
                       
                        <div class="top20" >You may request the deletion of your account and all your personal data. 
                          We will send a notification to the email address registered to your account once the deletion has been completed. 
                          If you have paid for services that are still active you will not receive a refund. This action cannot be reversed. All slinks in your account will be released and become available for other users to register.
                        </div>
                       
    
                        <div class="field">
                            <button v-if="!sure" id="save4" @click="submitForm5" class="button is-warning top10 is-small">DELETE ACCOUNT</button>
                            <div class="top10" v-if="sure">
                                <div >Are you Sure?</div>
                                <button class="button is-warning top5 is-small" @click="delAccount" id='yes'>Yes</button>&nbsp;<button class="button top5 is-small" @click="cancelDel">Cancel</button>
                            </div>
                        </div>
                 
                    </div>
    
                    <div v-if="!showForm">
                        <div class="is-size-4">
                            Thank you!
                        </div>
                        <div>
                            {{successMessage}}
                        </div>
                        <div class="top20">
                            <button class="button is-warning" @click="$router.push('/')">HOME</button>
                        </div>
    
                    </div>
                </div>
                </div>
                <div class="column is-hidden-mobile">
                     <!--  <img src="@/assets/img/serpiente.png"  /> -->
                </div>
  </div>
          </div>
       </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import countries from '../STATIC/countries.js'
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
export default {
  components: {
    MainLayout
  },
  data: function () {
    var form = {
      fName: this.$root.userAttrs.given_name,
      lName: this.$root.userAttrs.family_name,
      company: this.$root.userAttrs['custom:company'],
      city: this.$root.userAttrs['custom:city'],
      country: this.$root.userAttrs['custom:countryCode']
    }

    var form2 = {
      oldPassword: '',
      password: ''
    }

    var form3 = {
      email: ''
    }

    return {
      form: form,
      form2: form2,
      form3: form3,
      showForm: true,
      successMessage: '',
      countries: countries,
      sure: false
    }
  },
  watch: { // when /accsettings page is refreshed or freshly loaded sesson is checked, must refresh attr values:
    '$root.userAttrs': function (newVal, oldVal) {
      this.form.fName = this.$root.userAttrs.given_name,
      this.form.lName = this.$root.userAttrs.family_name,
      this.form.company = this.$root.userAttrs['custom:company'],
      this.form.city = this.$root.userAttrs['custom:city'],
      this.form.country = this.$root.userAttrs['custom:countryCode']
    }
  },
  mounted: function () {

  },
  methods: {
    submitForm1: function () {
      var self = this
      this.$validator.validateAll('form1').then((res) => {
        if (res) {
          updateAttrs()
        } else {
          this.$root.showModalOK({message: 'Please correct the errors or omissions on the form'})
        }
      })

      function updateAttrs () {
        az.addRemSpinner(true, 'id', 'save1');

        var attributes = [
          {Name: 'given_name', Value: self.form.fName},
          {Name: 'family_name', Value: self.form.lName},
          {Name: 'custom:company', Value: self.form.company},
          {Name: 'custom:city', Value: self.form.city},
          {Name: 'custom:countryCode', Value: self.form.country}
        ]

        self.$root.azCognito.updateAttributes(attributes, updateAttrsCallback)

        function updateAttrsCallback (result, obj) {
          az.addRemSpinner(false, 'id', 'save1');
          if (result == 'success') {
            self.successMessage = 'Your personal information has been successfully updated.'
            self.showForm = false

            for (var i = 0; i < attributes.length; i++) {
              self.$root.userAttrs[attributes[i].Name] = attributes[i].Value
            }
          } else if (result == 'error') {
            self.$root.showModalOK({message: 'There was an error updating your information. Please try again.'})
          }
        }
      }
    },
    submitForm2: function () {
      var self = this
      this.$validator.validateAll('form2').then((res) => {
        if (res) {
          // this.showForm = false;
          changePassword()
        } else {
          this.$root.showModalOK({message: 'Please correct the errors or omissions on the form.'})
        }
      })

      function changePassword () {
        az.addRemSpinner(true, 'id', 'save2');

        self.$root.azCognito.changePassword(self.form2.oldPassword, self.form2.password, changePasswordCallback)

        function changePasswordCallback (result, err) {
          az.addRemSpinner(false, 'id', 'save2');
          if (result == 'error') {
            if (err.code == 'InvalidParameterException' || err.code == 'NotAuthorizedException') {
              self.$root.showModalOK({message: 'The old password you provided is incorrect. If you have forgotten it, you may use the Forgot Password procedure after logging out.'})
            } else if (err.code == 'LimitExceededException') {
              self.$root.showModalOK({message: 'The attempts limit within a time period has been reached, please try again later'})
            }
            return
          }
          self.successMessage = 'Your password has been successfully updated.'
          self.showForm = false
          window.scrollTo(0, 0)
        }
      }
    },
    submitForm3: function () {
      var self = this
      this.$validator.validateAll('form3').then((res) => {
        if (res) {
          updateEmail()
        } else {
          this.$root.showModalOK({message: 'Please correct the errors or omissions on the form.'})
        }
      })

      function updateEmail () {
        az.addRemSpinner(true, 'id', 'save3');

        var attributes = [
          {Name: 'email', Value: self.form3.email.toLowerCase()}
        ]

        self.$root.azCognito.updateEmail(attributes, updateEmailCallback)

        function updateEmailCallback (result, obj) {
          az.addRemSpinner(false, 'id', 'save3');
          if (result == 'error') {
            if (obj.code == 'AliasExistsException') {
              self.$root.showModalOK({message: 'The email provided is already in use! please provide a different one.'})
            } else {
              self.$root.showModalOK({message: 'There was an error updating your information. Please try again.'})
            }
            return
          }

          self.successMessage = 'We have sent a confirmation email to ' + self.form3.email.toLowerCase() + ' with a code. Please log back in with your the new email address and provide the code we sent you when prompted.'
          self.showForm = false
          self.$root.isAuth = false

          for (var i = 0; i < attributes.length; i++) {
            self.$root.userAttrs[attributes[i].Name] = attributes[i].Value
          }
        }
      }
    },

    submitForm4: function () {
      var self = this;
      
      function w(){
          az.addRemSpinner(false, 'id', 'save4')
          self.showForm = false
          self.successMessage = 'Your data request has been sent.'
      }

      function n(){
         az.addRemSpinner(false, 'id', 'save4')
      }

      az.addRemSpinner(true, 'id', 'save4')
      this.$root.apiClient.post('api/account/datarequest', {}, w, n)
    },

    submitForm5: function() {
      this.sure = true
    },
    cancelDel: function() {
      this.sure = false
    },

    delAccount: function(){
      var self  = this
      
      //TODO send deletion request
      function w(d){
         az.addRemSpinner(false, 'id', 'yes')
          self.successMessage = 'Your account deletion request has been sent.'
          self.sure = false
          self.showForm = false
      }

      function n(){
           az.addRemSpinner(false, 'id', 'yes')
      }

      az.addRemSpinner(true, 'id', 'yes')
      this.$root.apiClient.post('api/account/delaccount', {}, w, n)
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/AccSettings.vue